export function getBase64(file: File, asDataUrl: boolean = false): Promise<string> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = function () {
            let result = reader.result as string
            if (!asDataUrl) {
                result = rawBase64(result)
            }
            resolve(result)
        }
        reader.onerror = function (error) {
            reject(error)
        }
    })
}

function rawBase64(dataUrl: string): string {
    const split = dataUrl.split('base64,')
    if (split.length < 2) throw new Error('Invalid data url string')
    return split[1]
}
